<template>
  <div
    :class="['basic_text cmp-inner', module.isEditing ? 'basic_text_editing' : '', module.textType == 'positionInfo'?'grayBj':'']"
    @dblclick.capture="on_double_click"
    @click="on_click"
    :style="style"
  >
    <div
      class="my-text-wrapper my-contenteditable"
      @focus="onFocusContentEditable"
      @blur="onBlurContentEditable"
      @mouseup="onMouseUpContentEditable"
      @keydown="onKeyDownContentEditable"
      @paste="onPaste"
      v-html="module.text"
    ></div>
  </div>
</template>

<script type="text/javascript">
import { richTextHelper } from '@/base/richTextHelper'

// window.richTextHelper = richTextHelper  // 开发调试用

export default {
  name: 'BasicTextIndex',
  data() {
    return {
      is_editing: false
    }
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: 'edit'
    }
  },
  computed: {
    style() {
      let style = this.utils.getStyle(this.module.style)
      if (this.module.is_art && this.module.artType !== 'plainStroke' && this.module.properties) {
        style = {
          ...style
        }
      }
      return style
    },
    is_select() {
      if (!this.$store.state.widgets.module_Data) {
        return false
      }
      return this.module.tid === this.$store.state.widgets.module_Data.tid
    },
    is_center() {
      return this.type === 'edit'
    },
    font_family() {
      return this.module.style['font-family']
    },
    fixLayoutSizeConfig() {
      if (this.module.style['writing-mode'] === 'vertical-lr') {
        return {
          height: this.module.style.height,
          text: this.module.text,
          'font-size': this.module.style['font-size'],
          'line-height': this.module.style['line-height']
        }
      } else {
        return {
          width: this.module.style.width,
          text: this.module.text,
          'font-size': this.module.style['font-size'],
          'line-height': this.module.style['line-height']
        }
      }
    }
  },
  watch: {
    'module.shadowisShow'(val) {
      if (val === false) {
        this.module.shadow.x = 0
        this.module.shadow.y = 0
      }
    },
    '$store.state.widgets.module_Data'(val, old) {
      this.$nextTick(() => {
        const module = this.$store.state.widgets.module_Data
        if (!module || module.tid !== this.module.tid) {
          if (!$(`#u${this.module.tid} .my-contenteditable`).length) {
            return
          }
          if (window.getSelection().toString()) {
            richTextHelper.unselect_text_widget(this.module.tid)
          }
          $(`#u${this.module.tid} .my-contenteditable`).attr('contenteditable', false)
          this.module.isEditing = false
          const html = $(`#u${this.module.tid} .my-contenteditable`).html()
          if (this.module.text !== html) {
            this.module.text = html
          }
        }
      })
    },
    is_select() {
      if (!this.is_select) {
        this.is_editing = false
      }
    },
    fixLayoutSizeConfig: {
      handler: function(now, old) {
        this.fixLayoutSize()
      },
      deep: true
    }
  },
  methods: {
    onContentChange() {},
    on_click() {
      // console.log('on_click')
    },
    on_double_click() {
      if (this.module.textType) return // 除自定义字体外不允许编辑
      this.is_editing = true
      this.module.isEditing = true
      this.module.on_double_click = 1
      $(`#u${this.module.tid} .my-contenteditable`).attr('contenteditable', true)
      richTextHelper.select_text_widget(this.module.tid)
    },
    fixHeight() {
      this.$nextTick(() => {
        if (this.module.style.height === 'auto') {
          return
        }
        const $el = $(`#u${this.module.tid} .my-contenteditable`)
        if (!$el.length) {
          return
        }
        let innerHeight = $el[0].offsetHeight
        innerHeight = Number(innerHeight.toFixed(0))
        if (this.module.style.height < innerHeight) {
          this.module.style.height = innerHeight
        }
        if (this.module.style.height > innerHeight + 200) {
          this.module.style.height = 'auto'
        }
      })
    },
    fixWidth() {
      // 只有竖向排盘需要修正宽度，横向排版的宽度是固定的
      if (this.module.style['writing-mode'] !== 'vertical-lr') {
        return
      }
      if (this.module.style.height === 'auto') {
        return
      }
      const $el = $(`#u${this.module.tid} .my-contenteditable`)
      if (!$el.length) {
        return
      }
      let innerWidth = $el[0].offsetWidth
      innerWidth = Number(innerWidth.toFixed(0))
      if (this.module.style.width < innerWidth) {
        this.module.style.width = innerWidth
      }
    },
    onMouseUpContentEditable() {
      richTextHelper.saveSelection()
    },
    onKeyDownContentEditable() {
      this.fixLayoutSize()
    },
    onBlurContentEditable() {
      // console.log('blur')
    },
    onFocusContentEditable() {
      // console.log('onFocusContentEditable')
    },
    onPaste(e) {
      // 必须是在编辑状态下才能粘贴
      if (!this.is_editing) {
        return
      }
      e.preventDefault()
      var text = null

        if (window.clipboardData && clipboardData.setData) {
          // IE
          text = window.clipboardData.getData('text')
        } else {
          text = (e.originalEvent || e).clipboardData.getData('text/plain') || prompt('在这里输入文本')
        }
      if (document.body.createTextRange) {
        let textRange
        textRange.text = text
        textRange.collapse(false)
        textRange.select()
      } else {
        // Chrome之类浏览器
        document.execCommand('insertText', false, text)
      }
    },
    insert_font_face_in_style() {
      const font_name = this.module.style['font-family'] || ''
      this.utils.insert_font_face(font_name)
    },
    getFontListInRichText(text) {
      // 数据是这样的格式<font face="font-1">测试</font>
      let fontList = (text || '').match(/face="\s*font-?(.*?)"/g) || []
      fontList = fontList.map(f => {
        return f.split('"')[1]
      })
      return fontList
    },
    insertFontFIleInRichText() {
      const fontList = this.getFontListInRichText(this.module.text)
      fontList.forEach(f => {
        this.utils.insert_font_face(f)
      })
    },
    fixLayoutSize() {
      if (!this.module.autoFixLayoutSize) {
        return
      }
      // 水平排版的文字，只需要处理高度，宽度会自动换行
      // 竖直排盘的文字，只需要处理宽度，高度会自动换行
      if (this.module.style['writing-mode'] === 'vertical-lr') {
        this.fixWidth()
      } else {
        this.fixHeight()
      }
    },
    fixField() {
      if (this.type === 'stroke') {
        // 灰度测试期间产生的历史数据，这个字段叫type不好，改一下
        this.module.artType = 'plainStroke'
      }
      if (!this.module.shadow) {
        this.$set(this.module, 'shadow', {
          x: 0,
          y: 0,
          blur: 0,
          color: '#000'
        })
      }
    }
  },
  created() {
    this.$set(this.module, 'isEditing', false)
    this.$set(this.module, 'autoFixLayoutSize', true)
    this.fixField()
    this.insert_font_face_in_style()
    this.insertFontFIleInRichText()
  },
  mounted() {
    // this.module.text = '<div data-v-248ba84c="" style="font-family: font-8; font-size: 18px; line-height: 18px; width: 212px; color: rgb(32, 151, 243); background: rgb(131, 198, 131) none repeat scroll 0% 0%; height: 35px;"><div data-v-248ba84c="" class="rich-content" contenteditable="true"><p><font color="rgba(32,151,243,1)"><span style="font-size: 18px;">请双击输入文字</span></font></p></div></div>'
    // 火狐浏览器font标签的color属性不能是rgba,所以要用styleWithCSS
    document.execCommand('styleWithCSS', null, true)
  },
  components: {}
}
</script>

<style lang="scss" scoped>
.basic_text {
  min-height: 20px;
  user-select: initial;
  ::v-deep img{
    width: 14px;
    margin-right: 8px;
    vertical-align: middle;
  }
}
.grayBj{
    border-radius: 4px;
}
.basic_text ::v-deep .edui-default .edui-editor-toolbarbox {
  display: none;
}

.basic_text ::v-deep .rich-content {
  em,
  i {
    font-style: italic;
  }

  &:focus-visible {
    outline: none;
  }

  //white-space: nowrap
}

.basic_text ::selection {
  //background: transparent;
}

.basic_text {
  div {
    border-style: solid;
    border-width: 0;
  }
}

.my-text-wrapper {
  height: auto;
}

.my-contenteditable {
  outline: none;
  user-select: auto;
  -webkit-user-select: auto;
}

.basic_text_editing {
  cursor: text;
}

.my-text-wrapper {
  span,
  font,
  i,
  b {
    display: inline-block;
    vertical-align: baseline;
  }
}
</style>
<style>
.my-contenteditable i {
  font-style: italic;
}
</style>
